export default __webpack_public_path__ + "9a6bd70c5b69106cf17cc9fe2530a8ff.svg";